import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'proforma-invoice',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "HEADER":[
            { index: 1, name: ['发送订单'], icon: 'fas fa-paper-plane', check_lines: 0, on_click: [], sign: 'sendOrder', },
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            { index: 0, name: ['清除发送状态'], icon: 'fas fa-trash', check_lines: 0, on_click: [], sign: 'clear', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        colseDialogFun:null,
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'proforma-invoice-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'purchaseOrder/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
    }
}
const state = () => ({
    purchaseOrder: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.purchaseOrder.pageConfig,
    getPageConfigTree: state => state.purchaseOrder.pageConfigTree,
    getPageKey:state => state.purchaseOrder.pageKey,
    getPushDataDialog:state => state.purchaseOrder.dialogPage,
    getPushDataPageKey:state => state.purchaseOrder.dialogPage.pageKey,
}
const mutations ={
    setRestPageFun(state, data){
        state.purchaseOrder.resetPage = data;
    },
    setLoading(state, data){
        state.purchaseOrder.loading = data;
        if(isNotEmpty(state.purchaseOrder.pageConfig)){
            Object.keys(state.purchaseOrder.pageConfig).forEach((key,index)=>{
                state.purchaseOrder.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.purchaseOrder.pageConfig = data.pageConfig;
        state.purchaseOrder.pageConfigTree = data.allArrData;
        state.purchaseOrder.pageKey = getRandomString();
        if(isNotEmpty(state.purchaseOrder.pageConfig)){
            Object.keys(state.purchaseOrder.pageConfig).forEach((key,index)=>{
                state.purchaseOrder.pageConfig[key].height = state.purchaseOrder.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.purchaseOrder.dialogPage.pageConfig = data.pageConfig;
        state.purchaseOrder.dialogPage.pageConfigTree = data.allArrData;
        state.purchaseOrder.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.purchaseOrder.dialogPage.pageConfig)){
            Object.keys(state.purchaseOrder.dialogPage.pageConfig).forEach((key,index)=>{
                state.purchaseOrder.dialogPage.pageConfig[key].height = state.purchaseOrder.height
            })
        }
    },
    setPushDialogList(state, data){
        state.purchaseOrder.dialogPage.pageConfig[data.obj].data = data.data;
        state.purchaseOrder.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        state.purchaseOrder.pageConfig[data.obj].data = data.data;
        state.purchaseOrder.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.purchaseOrder.height = (data-50) + 'px';
        if(isNotEmpty(state.purchaseOrder.pageConfig)){
            Object.keys(state.purchaseOrder.pageConfig).forEach((key,index)=>{
                state.purchaseOrder.pageConfig[key].height = state.purchaseOrder.height;
            })
        }
        state.purchaseOrder.dialogPage.height = (data-50) + 'px';
        if(isNotEmpty(state.purchaseOrder.dialogPage.pageConfig)){
            Object.keys(state.purchaseOrder.dialogPage.pageConfig).forEach((key,index)=>{
                state.purchaseOrder.dialogPage.pageConfig[key].height = state.purchaseOrder.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.purchaseOrder.pageConfig,pageConfigTree:state.purchaseOrder.pageConfigTree});
    }
}
const actions = {
    ['clearDelete']({ state, dispatch, rootState ,commit}, payload) {
        if(state.purchaseOrder.loading) return;
        commit('setLoading',true);
        let msg = { command: "delete_client__erp_purchase_send_tag", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['clear_return']({ state, dispatch, rootState ,commit}, payload) {
        commit('setLoading',false);
        if(payload.success){
            dispatch('response/info-tip', { message: payload.data }, { root: true })
            state.purchaseOrder.resetPage({});
        }
    },
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.purchaseOrder.loading) return;
        commit('setLoading',true);
        console.log('payload',JSON.stringify(payload),'payloadpayloadpayload');
        let msg = { command: "get_client__erp_purchase", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            let params = JSON.parse(JSON.stringify(payload));
            if(!isNotEmpty(state.purchaseOrder.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.purchaseOrder.tableName,top_tools:state.purchaseOrder.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.purchaseOrder.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.purchaseOrder.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__erp_purchase_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
